// extracted by mini-css-extract-plugin
module.exports = {"confirmationText":"ResetPasswordEmailSent_confirmationText__1s4Oc"};